import { Page } from '../components';
import { InvoiceAuditForm } from '../forms/InvoiceAuditForm';

export const InvoiceAudit = () => (
  <Page render={() => <InvoiceAuditForm />} />
);
